export default "__VITE_ASSET__DE15oNXh__"